/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Reverse geocode service implementation.
 *
 * It allows to convert geographical coordinates into textual address representation using the TomTom's
 * [Search API - Reverse Geocode](https://developer.tomtom.com/search-api/search-api-documentation-reverse-geocoding/reverse-geocode).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "ReverseGeocode/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *   {{#crossLink "ReverseGeocode/go:method"}}{{/crossLink}} method to handle the response.
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * The final response from service is a JSON object with the following structure:
 *
* ```js
 * {
 *   "summary": {
 *       "queryTime": 172,
 *       "numResults": 1
 *   },
 *   "addresses": [
 *       {
 *           "address": { // Structured Address for the result
 *               "buildingNumber": "2515",
 *               "streetNumber": "2515",
 *               "routeNumbers": [],
 *               "street": "Soquel Dr",
 *               "streetName": "Soquel Dr",
 *               "streetNameAndNumber": "2515 Soquel Dr",
 *               "countryCode": "US",
 *               "countrySubdivision": "CA",
 *               "countrySubdivisionName": "California",
 *               "municipality": "Santa Cruz",
 *               "sideOfStreet": "R",
 *               "offsetPosition": "36.988240,-121.974790",
 *               "country": "United States of America",
 *               "countryCodeISO3": "USA",
 *               "freeformAddress": "2515 Soquel Dr\nSanta Cruz CA 95065",
 *               "boundingBox": {
 *                   "northEast": "36.99265,-121.96917",
 *                   "southWest": "36.98365,-121.98043",
 *                   "entity": "position"
 *               },
 *           },
 *           "position": "36.98815,-121.97480",
 *           "matchType": "HouseNumberRange",
 *           "roadUse": [
 *               "LocalStreet"
 *           ]
 *       }
 *   ],
 *   "spatialKeys": []
 * }
 * ```
 *
 * @example
 * ```js
 * function callbackFn(response) {
 *   console.log(response);
 * }
 * tomtom.reverseGeocode()
 *   .position("51.759,19.449")
 *   .go()
 *   .then(callbackFn);
 * ```
 *
 * @class ReverseGeocode
 * @module Services
 * @uses Chain
 * @uses KeyMixin
 * @uses ProtocolMixin
 * @uses RadiusMixin
 * @uses PositionMixin
 * @uses SpatialKeysMixin
 * @uses LanguageMixin
 * @uses ViewMixin
 * @uses HeadingMixin
 * @uses AllowFreeformNewlineMixin
 *
 * @constructor
 * @param {Object}   [options] Options to be passed to the reverse geocode call,
 *     or Array of such options objects to perform batch request.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 *
 * @param {String|Array|Object} options.position Specific longitude and latitude of the location where the address
 *     is supposed to be found.
 *     The possible formats are explained in more detail in the
 *     {{#crossLink "ReverseGeocode/position:method"}}{{/crossLink}} method.
 *     This option is required to make the call.
 * @param {String} [options.key] API Key valid for requested service.
 * @param {Boolean} [options.spatialKeys=false] DEPRECATED! If is enable the response will also contain a proprietary geo-spatial
 *     key information for a specified location
 * @param {Boolean} [options.returnSpeedLimit=false] To enable return of the posted speed limit (where
 *     available).
 * @param {Number} [options.heading] The directional heading of the vehicle in degrees, for travel along a
 *     segment of roadway.
 *     `0` is North, `90` is East and so on, values range from `-360` to `360`.
 *     The precision can include up to one decimal place.
 * @param {Number} [options.radius=10000] The maximum distance in meters from the specified position to consider
 * @param {String} [options.number] If a street number is sent in along with the request, the response
 *     may include the side of the street (Left/Right) and also an offset position for that street number.
 * @param {Boolean} [options.returnRoadUse=false] Requires to include a road use array for reversegeocodes at street level
 * @param {String[]|String} [options.roadUse] To restrict the result to one or a group of the following road uses:
 *      `LimitedAccess`, `Arterial`, `Terminal`, `Ramp`, `Rotary`, `LocalStreet`.
 * @param {String} [options.language] Preferred language and script in which search results (including place names) are returned.
 *     If language is not specified, the default official name will be returned in response. Supported languages are listed in the
 *     documentation of the service. If requested language is not supported, a special error code will be returned.
 * @param {Boolean} [options.returnMatchType] Include information on the type of match the geocoder achieved in the response.
 * @param {Boolean} [options.allowFreeformNewline=false] Format of newlines in the formatted address.
 *     If true, the address will contain newlines.
 *     If false, newlines will be converted to commas.
 * @param {String} [options.view=Unified] The geopolitical view used in subsequent calls
 */
/* eslint-enable */
define(['./reverseGeocodeBase', './reverseGeocodeParameters', './types'],
    function(reverseGeocodeBase, reverseGeocodeParams, types) {
        'use strict';

        var ReverseGeocodeBasePrototype = reverseGeocodeBase.prototype.constructor;

        function ReverseGeocode(options) {
            ReverseGeocodeBasePrototype.call(this, options);
            this.fields = reverseGeocodeParams(types.reverseGeocode);
        }

        ReverseGeocode.prototype = new ReverseGeocodeBasePrototype();
        ReverseGeocode.prototype.constructor = ReverseGeocode;

        return function(options) {
            return (new ReverseGeocode(options)).construct();
        };
    });



// WEBPACK FOOTER //
// ./services/reverseGeocode/reverseGeocode.js